<template>
    <div>
          <div class="text-center pt-4" v-if="loading == true">
            <div class="row ml-1" v-for="option in 10">
              <div class="res_heading_1" style=" padding-left: 0px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="res_heading_2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>

        <div v-if="statusUpdateSuccessMsg" class="text-green">{{ statusUpdateSuccessMsg }}</div>
        <div v-if="statusUpdateErrorMsg" class="text-red">{{ statusUpdateErrorMsg }}</div>
        <div class="row mt-4" v-if="loading == false">
            <div class="col-12">
                <input 
                    type="checkbox" 
                    id="mentee_app_settings" 
                    v-model="privileges_selected" 
                    value="1"
                    @click="updateSettings($event, 'privileges')"
                    :checked="privileges_selected">&nbsp;
                <label for="mentee_app_settings">Mentees and Apprentices can submit reps for review</label>
            </div>
        </div>
        <div class="row mt-3" v-if="loading == false">
            <div class="col-12">
                <input 
                    type="checkbox" 
                    id="primary_admin_settings" 
                    v-model="primary_admin_renew_subscription" 
                    value="1"
                    @click="updateSettings($event, 'renew')"
                    :checked="primary_admin_renew_subscription">&nbsp;
                <label for="primary_admin_settings">Primary Admin can renew subscription</label>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    props: ['accountId'],
    data() {
        return {
            loading: false,
            privileges_selected: '',
            primary_admin_renew_subscription: '',
            statusUpdateSuccessMsg: '',
            statusUpdateErrorMsg: '',
            privileges_selected_modified: false,
            primary_admin_renew_subscription_modified: false,
        }
    },
    methods: {
        updateSettings(event, input) {
            if (event.target.checked) {
                if (input == 'renew') {
                    this.primary_admin_renew_subscription = true;
                    this.primary_admin_renew_subscription_modified = true;
                } else {
                    this.privileges_selected = true;
                    this.privileges_selected_modified = true;
                }
            } else {
                if (input == 'renew') {
                    this.primary_admin_renew_subscription = false;
                    this.primary_admin_renew_subscription_modified = true;
                } else {
                    this.privileges_selected = false;
                    this.privileges_selected_modified = true;
                }
            }
            this.submitSettings();
        },
        submitSettings() {
            this.loading = true;
            axios('/enterprise-admin/update-account-settings/' + this.accountId,
            {
                method: 'POST',
                data: {
                    privileges_selected: this.privileges_selected,
                    primary_admin_renew_subscription: this.primary_admin_renew_subscription,
                    primary_admin_renew_subscription_modified: this.primary_admin_renew_subscription_modified,
                    privileges_selected_modified: this.privileges_selected_modified,
                }
            })
            .then(resp => {
                this.loading = false;
                this.primary_admin_renew_subscription_modified = false;
                this.privileges_selected_modified = false;
                this.statusUpdateSuccessMsg = "Account settings updated successfully";
                this.clearFlashMessage();
            })
            .catch(() => {
            });
        },
        clearFlashMessage() {
            setTimeout(() => {
                this.statusUpdateSuccessMsg = '';
                this.statusUpdateErrorMsg = '';
            }, 2000);
        }
    },
    created() {
        this.loading = true;
        this.statusUpdateSuccessMsg = false;
        if (this.accountId > 0) {
            axios('/enterprise-admin/location-overview',
            {
                method: 'GET',
                params: {
                    account_id: this.accountId,
                }
            })
            .then(resp => {
                this.loading = false;
                this.privileges_selected = resp.data.submitReps;
                this.primary_admin_renew_subscription = resp.data.primaryAdminRenew;
            })
            .catch(() => {
            });
        }
    }
}
</script>
<style scoped>
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.res_heading_1 { width: 10%; }
.res_heading_2 { width: 90%; }

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/settings_tab.vue